import { useEffect } from "react";
import { saveAs } from "file-saver";
import XLSX from "sheetjs-style";

const ExportExcel = ({ excelData, fileName, setExportView }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(excelData, { skipHeader: true });

    // Apply column widths
    ws["!cols"] = [{ wch: 15 }, { wch: 15 }, { wch: 30 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "data");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    saveAs(data, fileName + fileExtension);

    // Optionally set export view to false after exporting
    setExportView(false);
  };

  // Run the exportToExcel function when the component mounts
  useEffect(() => {
    exportToExcel();
  }, []);

  return null; // No need to return any JSX
};

export default ExportExcel;
